// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"d18928ea","71":"c2edd2d7","249":"abbb3d16","791":"0fccb36b"}[chunkId] + ".js";
};